<template>
  <div>
    <div class="container" v-if="isForm">
      <p class="text-center h5">
        您可以上傳本縣災害歷史照片與描述，經審核後將會作為本縣歷史災害紀錄，<br />感謝您的參與，讓我們一起見證歷史，創造未來。
      </p>
      <form class="form-collection" method="post" enctype="multipart/form-data">
        <h3>基本資料</h3>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="name">姓名</label>
              <input
                type="text"
                class="form-control"
                name="name"
                id="name"
                v-model.trim="$v.forms.name.$model"
                :class="{ 'is-invalid': $v.forms.name.$error }"
                maxlength="30"
              />
              <div class="invalid-feedback" v-if="!$v.forms.name.required">
                此欄位為必填
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="email">電子信箱</label>
              <input
                type="text"
                class="form-control"
                name="email"
                id="email"
                v-model.trim="$v.forms.email.$model"
                :class="{ 'is-invalid': $v.forms.email.$error }"
                maxlength="50"
              />
              <div class="invalid-feedback" v-if="!$v.forms.email.required">
                此欄位為必填
              </div>
              <div class="invalid-feedback" v-if="!$v.forms.email.email">
                請輸入正確的電子郵件
              </div>
            </div>
          </div>
        </div>
        <h3>災害資訊</h3>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="subject">相簿主題</label>
              <input
                type="text"
                class="form-control"
                name="subject"
                id="subject"
                v-model.trim="$v.forms.subject.$model"
                :class="{ 'is-invalid': $v.forms.subject.$error }"
                maxlength="50"
              />
              <div class="invalid-feedback" v-if="!$v.forms.subject.required">
                此欄位為必填
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="kind">災害類別</label>
              <select
                class="form-control"
                name="kind"
                id="kind"
                v-model.trim="$v.forms.kind.$model"
                :class="{ 'is-invalid': $v.forms.kind.$error }"
                @change="$v.forms.kind.$touch()"
              >
                <option value="">請選擇</option>
                <option
                  v-for="(kind, index) in kinds"
                  :key="index"
                  :value="kind.id"
                  >{{ kind.title }}</option
                >
              </select>
              <div class="invalid-feedback" v-if="!$v.forms.kind.required">
                必須選擇
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="occurdate">災害發生日期</label>
              <date-picker
                :config="options"
                class="form-control datepicker"
                id="occurdate"
                name="occurdate"
                maxlength="10"
                placeholder="請選擇日期"
                v-model.trim="$v.forms.occurdate.$model"
                :class="{ 'is-invalid': $v.forms.occurdate.$error }"
              ></date-picker>
              <div class="invalid-feedback" v-if="!$v.forms.occurdate.required">
                此欄位為必填
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="occurtime">災害發生時間</label>
              <input
                type="text"
                class="form-control timepicker"
                name="occurtime"
                id="occurtime"
                v-model.trim="$v.forms.occurtime.$model"
                :class="{ 'is-invalid': $v.forms.occurtime.$error }"
                maxlength="30"
              />
              <div class="invalid-feedback" v-if="!$v.forms.occurtime.required">
                此欄位為必填
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="location">災害鄰近地址或道路里程</label>
              <input
                type="text"
                class="form-control"
                name="location"
                id="location"
                placeholder="請輸入災害鄰近地址或道路里程，例如:竹北市光明六路OO號或縣122南清公路8.7K"
                v-model.trim="$v.forms.location.$model"
                :class="{ 'is-invalid': $v.forms.location.$error }"
                maxlength="100"
              />
              <div class="invalid-feedback" v-if="!$v.forms.location.required">
                此欄位為必填
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="description">災害描述</label>
              <input
                type="text"
                class="form-control"
                name="description"
                id="description"
                v-model.trim="$v.forms.description.$model"
                :class="{ 'is-invalid': $v.forms.description.$error }"
                maxlength="200"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.forms.description.required"
              >
                此欄位為必填
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="photos">歷史災害照片上傳</label>
              <div class="input-upload">
                <input
                  type="file"
                  ref="file"
                  id="photos"
                  name="photos"
                  accept=".jpg,.jpeg"
                  aria-describedby="text-upload-help"
                  multiple
                  @change="fileChange"
                />
                <span class="form-control" :class="{ 'is-invalid': !isPicker }"
                  >請選擇檔案</span
                >
                <small id="text-upload-help" class="form-text text-muted"
                  >單一檔案大小限制為 1MB，檔案格式為 JPG、JPEG。</small
                >
                <div class="invalid-feedback" v-if="!isPicker">
                  請選擇檔案，至少需上傳一張 JPG 或 JPEG
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="latitude">災害緯度座標N</label>
              <input
                type="text"
                class="form-control"
                name="latitude"
                id="latitude"
                aria-describedby="helpId"
                placeholder="數字較小為緯度，如 24.827084"
                v-model.trim="$v.forms.latitude.$model"
                :class="{ 'is-invalid': $v.forms.latitude.$error }"
                maxlength="30"
              />
              <div class="invalid-feedback" v-if="!$v.forms.latitude.required">
                此欄位為必填
              </div>
              <a
                href="https://support.google.com/maps/answer/18539?hl=zh-Hant"
                class="form-text"
                target="_blank"
                ><small id="helpId" class="text-muted"
                  ><i class="fas fa-info-circle"></i
                  >如何取得災害照片地理座標？</small
                ></a
              >
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="longitude">災害經度座標E</label>
              <input
                type="text"
                class="form-control"
                name="longitude"
                id="longitude"
                placeholder="數字較大為經度，如 121.010742"
                v-model.trim="$v.forms.longitude.$model"
                :class="{ 'is-invalid': $v.forms.longitude.$error }"
                maxlength="30"
              />
              <div class="invalid-feedback" v-if="!$v.forms.longitude.required">
                此欄位為必填
              </div>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-primary btn-lg"
            @click="clickSubmit"
            :disabled="submitStatus === 'PENDING'"
          >
            送出
          </button>
        </div>
      </form>
    </div>
    <div class="container" v-if="!isForm">
      <div class="jumbotron text-center">
        <p class="lead">感謝您的參與，經審核後將會作為本縣歷史災害紀錄</p>
        <router-link class="btn btn-primary btn-lg mr-3" to="/storymap"
          >首頁</router-link
        >
        <a href="/storymap/collection" class="btn btn-secondary btn-lg"
          >繼續提供</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { apiCollection, apiKind } from '@/api/index'
import datePicker from 'vue-bootstrap-datetimepicker'
import { required, email } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      kinds: [],
      forms: {
        name: '',
        email: '',
        subject: '',
        occurdate: '',
        occurtime: '',
        location: '',
        description: '',
        longitude: '',
        latitude: '',
        kind: '',
        photos: [],
      },
      options: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
      },
      submitStatus: null,
      isPicker: true,
      isForm: true,
    }
  },
  components: { datePicker },
  validations: {
    forms: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      subject: {
        required,
      },
      occurdate: {
        required,
      },
      occurtime: {
        required,
      },
      location: {
        required,
      },
      description: {
        required,
      },
      longitude: {
        required,
      },
      latitude: {
        required,
      },
      kind: {
        checked(val) {
          return val
        },
      },
    },
  },
  methods: {
    async getList() {
      await apiKind().then(response => {
        this.kinds = response.data
      })
    },
    clickSubmit() {
      this.submitStatus = 'PENDING'
      this.$v.$touch()
      this.checkFile()
      if (this.$v.$invalid || !this.isPicker) {
        this.submitStatus = 'ERROR'
      } else {
        this.Send()
      }
    },
    fileChange(event) {
      this.checkFile()
      var fileName = this.$(event.target).val().split('\\').pop(),
        btn = this.$(event.target).next('span')
      if (!btn.data('text')) btn.data('text', btn.html())
      if (!fileName) {
        fileName = btn.data('text')
      }
      btn.html(fileName)
      event.preventDefault()
    },
    checkFile() {
      let c = this.$refs.file.files
      if (0 >= c.length) this.isPicker = false
      else this.isPicker = true
    },
    async Send() {
      let loader = this.$loading.show()

      var formData = new FormData()
      formData.append('name', this.forms.name)
      formData.append('email', this.forms.email)
      formData.append('subject', this.forms.subject)
      formData.append('occurdate', this.forms.occurdate)
      formData.append('occurtime', this.forms.occurtime)
      formData.append('location', this.forms.location)
      formData.append('description', this.forms.description)
      formData.append('longitude', this.forms.longitude)
      formData.append('latitude', this.forms.latitude)
      formData.append('kind', parseInt(this.forms.kind))

      for (var i = 0; i < this.$refs.file.files.length; i++) {
        let file = this.$refs.file.files[i]
        formData.append('photos', file, file.name)
      }

      await apiCollection(formData)
        .then(response => {
          this.submitStatus = null
          this.isForm = false
          setTimeout(() => {
            loader.hide()
          }, 800)
        })
        .catch(err => {
          this.$swal('', err.response.data.detail, 'error')
          this.submitStatus = null
          setTimeout(() => {
            loader.hide()
          }, 800)
        })
    },
  },
  mounted() {
    this.getList()
  },
}
</script>
